import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"VisibleCards"}}
export type VisibleCardsQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID'];
}>;


export type VisibleCardsQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { cards: Array<(
      { __typename: 'Card' }
      & Pick<Types.Card, 'id'>
    )> }
  )> }
);


export const VisibleCardsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisibleCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"visible"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]};

/**
 * __useVisibleCardsQuery__
 *
 * To run a query within a React component, call `useVisibleCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibleCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibleCardsQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useVisibleCardsQuery(baseOptions: Apollo.QueryHookOptions<VisibleCardsQuery, VisibleCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisibleCardsQuery, VisibleCardsQueryVariables>(VisibleCardsDocument, options);
      }
export function useVisibleCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisibleCardsQuery, VisibleCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisibleCardsQuery, VisibleCardsQueryVariables>(VisibleCardsDocument, options);
        }
export type VisibleCardsQueryHookResult = ReturnType<typeof useVisibleCardsQuery>;
export type VisibleCardsLazyQueryHookResult = ReturnType<typeof useVisibleCardsLazyQuery>;
export type VisibleCardsQueryResult = Apollo.QueryResult<VisibleCardsQuery, VisibleCardsQueryVariables>;